
import d3 from 'd3'
import Backbone from 'backbone'
import LayerModel from '../models/LayerModel'
import ShapeView from './ShapeView'

const SVGShapeTagName = {
  Circle: 'circle',
  Ellipse: 'ellipse',
  Line: 'line',
  Path: 'path',
  Polygon: 'polygon',
  Polyline: 'polyline',
  Rect: 'rect',
}

function getTagName(type) {
  return SVGShapeTagName[type] || type
}

class LayerView extends Backbone.View {

  tagName() {
    return 'g'
  }

  render() {
    let {model, el} = this

    let $$el = d3.select(el)

    // Render elements.
    
    model.get('elements').each(function (element) {
      let subview = null

      if (element instanceof LayerModel) {
        subview = new LayerView({
          model: element,
          el: $$el.append('g').node()          
        })
      } else {
        subview = new ShapeView({
          model: element,
          el: $$el.append(getTagName(element.get('type'))).node()
        })
      }

      if (subview) {
        subview.render()
      }
    })

    return this
  }
}

export default LayerView
